import { connect } from "react-redux";
import KeywordTriggeredBanner from "components/atoms/KeywordTriggeredBanner";
import { getQueryFilterName, getPresetFilterValues } from "utils/filter";

const mapStateToProps = (state) => {
  const presetFilters = getPresetFilterValues();

  const hasFilterSet =
    state.filters &&
    Object.keys(state.filters).some(
      (key) =>
        key !== getQueryFilterName() &&
        !presetFilters[key] &&
        state.filters[key].values &&
        state.filters[key].values.length,
    );

  return {
    bannerMarkup:
      (!hasFilterSet &&
        state.keywordTriggeredBanner &&
        state.keywordTriggeredBanner.markup) ||
      "",
  };
};

const KeywordTriggeredBannerContainer = connect(mapStateToProps)(
  KeywordTriggeredBanner,
);

export default KeywordTriggeredBannerContainer;
